const initialState = {
    sidebar: [
    ],
    rightSidebar: [
        {
          links: [
            { name: 'Preferences', key: 'preferences' },
            { name: 'Log Out', key: 'logout' }
          ]
        },
    ],
    views: [
      {Name: "login", Type: "login"}
    ]
}

const configReducer = (state = initialState , action) => {

  let newState = state;

  if (action.type === 'UPDATECONFIG') {
    newState = action.value;
  }
  return newState;
}

export default configReducer;